/**
 * Feature flags for controlling visibility of incomplete features
 * Set to true when feature is ready for production
 */
export const FEATURES = {
  // Operations Module
  CALENDAR_ENABLED: false,
  HOUSEKEEPING_ENABLED: false,
  INSPECTIONS_ENABLED: true,
  MAINTENANCE_ENABLED: false,
  RULES_ENABLED: false,
  STORAGE_LOCATIONS_ENABLED: false,
  STORAGE_ITEMS_ENABLED: false,
  MANAGE_STOCK_ENABLED: false,
  STOCK_MOVEMENTS_ENABLED: false,
  HOME_INVENTORY_ENABLED: false,
  CLEANING_STANDARDS_ENABLED: false,
  PROPERTY_SETUP_ENABLED: false,
  CHECKLISTS_ENABLED: true,
  
  // Tasks Module
  TASKS_ENABLED: false,
  TASK_TEMPLATES_ENABLED: false,

  // Main Dashboard Cards
  WORK_ORDERS_MAIN_DASHBOARD_ENABLED: false,

  // Ops Dashboard Cards
  WORK_ORDERS_OPS_DASHBOARD_ENABLED: true,

};

export default FEATURES;